module.exports = "/_next/static/images/Hero@2x-dae61c28aebbecea0809f0e3ce33c3c0.png";